import { useQuery } from "@tanstack/react-query";
import { PalletService } from "src/services/pallets";
import { queryKeys } from "src/constants";
import { PalletPaginationOptions } from "src/types";

const usePallets = (palletService: PalletService, paginationOptions: PalletPaginationOptions) => {
  const {
    data: paginatedPallets,
    isLoading,
    isRefetching,
    error: fetchError,
    refetch: refreshPallets
  } = useQuery({
    queryKey: queryKeys.paginatedPallets(paginationOptions),
    queryFn: () => palletService.getPallets(paginationOptions)
  });

  return { paginatedPallets, isLoading, isRefetching, fetchError, refreshPallets };
};

export { usePallets };
